import React, { useEffect } from 'react'
import NavigationBar from '../components/NavigationBar'
import { MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow } from 'mdb-react-ui-kit'
import LandingFooter from '../components/LandingFooter'
import { Landing_Page, Software } from '../assets/images/images'
import FeaturesDetails from '../data/FeaturesDetails'
import ProductsDetails from '../data/ProductsDetails'
import RelatedProducts from '../components/RelatedProducts'
import { checkediconblack } from '../assets/images/images';
import ContactUs from '../components/ContactUs'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router';
// import easyvideo2 from '../../landingpage/assets/videos/Easymembr2.mp4';



const GymProducts = () => {


    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleDemoClick = () => {
        navigate('/bookademo');
    };

    const handlePricingClick = () => {
        navigate('/commercials');
    };

    useEffect(() => {
        const video = document.getElementById('customVideo');
        const playBtn = document.getElementById('playBtn');

        if (video && playBtn) {
            playBtn.addEventListener('click', () => {
                video.play();
                playBtn.style.display = 'none';
                video.setAttribute('controls', 'true');
            });
        }
    }, []);

    return (
        <>

            <div className="lp">
                <div className="home-section pt-0">
                    <NavigationBar classText="white-color" from='products' />
                    <MDBContainer className='pt-5'>
                        <MDBRow className="align-items-center">
                            <MDBCol size="md-6">
                                <div className="gym-promo">
                                    <h1 className="main-heading">Effortless
                                        Member
                                        Tracking
                                        &
                                        Engagement</h1>
                                    <p className="main-subtitle">
                                        Manage your gym, yoga studio, or sports center with a comprehensive platform designed for operational efficiency. Handle member tracking and class scheduling in a structured and organized manner to streamline daily activities and improve business operations.
                                    </p>

                                    <span
                                        className="btn btn-cta trial-button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#startTrialModal" onClick={handleDemoClick}
                                    >
                                        Book a Demo
                                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <a className="btn btn-cta btn-cta-outline-v2 demo-button" onClick={handlePricingClick}>
                                        Unlock your access
                                    </a>
                                </div>
                            </MDBCol>

                            <MDBCol size="md-6" className='gym-size'>
                                <img
                                    src={Landing_Page}
                                    className=" "
                                    alt="Hero Visual"
                                    width={850}
                                />
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </div>
            </div>





            <div className='section-white'>
                <MDBContainer className="lp_revenue p-0">
                    <MDBCol size='12' className='text-center my-5'>
                        <div div className='mb-3 h2'><span className='lp_revenue_header'>EasyMembr</span> Provides a premium 360-degree Suite to manage your gyms and sports clubs</div>
                        <p className='text-center'>
                            Manage your fitness business with a powerful, easy-to-use platform. From member tracking and class scheduling to lead management, EasyMembr 360-degree suite provides everything needed to streamline operations and enhance engagement. Whether you run a gym, yoga studio, MMA academy, or Zumba center, this solution helps you grow, organize, and simplify your business.
                        </p>
                    </MDBCol>
                    {ProductsDetails.map((feature) => (
                        <React.Fragment key={feature.id}>
                            <MDBRow className={feature.id % 2 == 0 ? 'flex-row-reverse' : ''}>
                                <MDBCol sm='12' md='6' className='my-5 d-flex flex-column justify-content-center'>
                                    <h3 className='lp_title_name mb-2'>
                                        {feature.title}
                                    </h3>
                                    <p className='mb-1'>{feature.desc}</p>

                                    <div className='mb-4 mt-3'>
                                        <MDBListGroup>
                                            {feature.description.map((text, index) => (
                                                <MDBListGroupItem noBorders className='lp_custom-list' key={index}>
                                                    <img
                                                        src={checkediconblack}
                                                        className='mr-3'
                                                        alt=""
                                                    />
                                                    {text}
                                                </MDBListGroupItem>
                                            ))}
                                            <Link to={feature.route}>
                                                <MDBListGroupItem noBorders className='lp_custom-list link-color'>
                                                    {feature.link}
                                                </MDBListGroupItem>
                                            </Link>
                                        </MDBListGroup>
                                    </div>
                                </MDBCol>
                                <MDBCol sm='12' md='6' className='my-5 text-center ip_slideimg'>
                                    <img src={feature.image} alt={feature.title} />
                                </MDBCol>
                            </MDBRow>
                        </React.Fragment>
                    ))}
                </MDBContainer>
            </div>



            <div className="section-white lp py-0">
                <MDBContainer>
                    <div className="row mt-4">
                        <div className="col-md-12 mb-3">
                            <div className="card shadow-0"> {/* gym-software-card */}
                                <div className="row align-items-center">
                                    <div className="col-md-12 pl-2 text-center mb-5">
                                        {/* <span className="badge-text">BEST GYM SOFTWARE</span> */}

                                        <h3 className="card-title">
                                            Unlock the Power of EasyMembr Software!
                                        </h3>
                                        <p className="card-description">
                                            Maximize customer retention, boost sales, and foster brand loyalty
                                            with EasyMembr top-rated Gym Software.
                                        </p>

                                        <span
                                            className="btn btn-cta btn-cta lp_fillbtn rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#startTrialModal" onClick={handlePricingClick}
                                        >
                                            Get Full Access Now!
                                        </span>

                                        <a href="" className="btn lp_outlinbtn ms-2 border border-2 border-primary rounded-1" onClick={handleDemoClick}>
                                            Book A Demo
                                        </a>
                                        &nbsp;
                                        {/* <a className="btn btn-cta-outline-v2 text-white" onClick={handlePricingClick}>
                                            Check Pricing
                                        </a> */}
                                    </div>

                                    {/* <div className="col-md-6 mb-5">
                                        <img
                                            src={Software}
                                            className="deskContentNew"
                                            alt="Pilates studio management software"
                                            loading="lazy"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="video-section">
                                <video id="customVideo" controls className='video1' preload="metadata" >
                                    {/* <source src={"https://zencruz-easymembr.s3.ap-south-1.amazonaws.com/videos/Easymembr_Intro.mp4"} type="video/mp4" /> */}
                                    <source src={"https://zencruz-easymembr.s3.ap-south-1.amazonaws.com/videos/Easymembr_Intro2.mp4"} type="video/mp4" />
                                </video>
                                <button id="playBtn"><i class="fas fa-play"></i></button>
                            </div>
                        </div>

                    </div>
                </MDBContainer>
            </div>


            <div className="section-grey">
                <ContactUs />
            </div>





            <LandingFooter />
        </>
    )
}

export default GymProducts
